import UniversalReport from '@tencent/universal-report';
import { IPageParams } from '@tencent/universal-report/lib/modules/PageManager';
import { useEffect } from 'react';

/**
 * 页面切入上报
 * @param reporter
 * @param params
 */
export const reportDtPgIn = (reporter: UniversalReport, params: IPageParams) => {
  console.log('datong|reportPgIn|pgid:', params.pgid);
  reporter.setPage(params, document.body);
  reporter.observe(params.pgid);
};

/**
 * 页面切出上报
 * @param reporter
 * @param params
 * @param duration
 */
export const reportDtPgOut = (reporter: UniversalReport, params: IPageParams, duration = 0) => {
  console.log('datong|reportPgOut|pgid:', params.pgid, ', duration:', params.duration);
  reporter.reportPgOut(params.pgid, true);
  // 真实曝光时长上报
  reporter.reportEvent({
    eventName: 'custom_pgout',
    pgid: params.pgid,
    businessParams: {
      custom_pgout_duration: duration,
      ...params,
    },
  });
  reporter.unobserve(params.pgid);
};

/**
 * 点击上报
 * @param reporter
 * @param productId
 * @param module
 * @param action
 * @param optional
 */
export const reportDtClick = (
  reporter: UniversalReport,
  module: string,
  action: string,
  optional?: {
    from?: string,
    cost?: number,
    result?: number,
    param1?: number,
    param2?: number,
    param3?: string,
    param4?: string,
    productId?: string,
  },
) => {
  console.log('datong|reportClick|module:', module, ', action:', action, ', optional:', JSON.stringify(optional));
  reporter.reportEvent({
    eventName: 'custom_click',
    businessParams: {
      module,
      action,
      rm_from: optional?.from,
      cost: optional?.cost,
      rm_result: optional?.result,
      param1: optional?.param1,
      param2: optional?.param2,
      param3: optional?.param3,
      param4: optional?.param4,
      productId: optional?.productId,
    },
  });
};

/**
 * 页面上报 hook
 * @param reporter
 * @param params
 */
export const useDtReportPage = (reporter: UniversalReport, params: IPageParams) => {
  let start = 0;
  let duration = 0;

  const onVisibilityChange = () => (document.visibilityState === 'visible' ? onVisible() : onInVisible());

  const onVisible = () => {
    start = Date.now();
  };

  const onInVisible = () => {
    const split = Date.now() - start;
    duration += split;
  };

  const pageIn = () => {
    document.addEventListener('visibilitychange', onVisibilityChange);
    onVisible();
    reportDtPgIn(reporter, params);
  };

  const pageOut = () => {
    document.removeEventListener('visibilitychange', onVisibilityChange);
    onInVisible();
    reportDtPgOut(reporter, params, duration);
  };

  useEffect(() => {
    pageIn();
    return () => pageOut();
  }, []);
};
